import LegalPageLayout from '../components/LegalPageLayout';

export default function KVKKPage() {
  const sections = [
    {
      title: 'Veri Sorumlusu',
      content: (
        <>
          <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak <strong className="text-white">Medyatik Interactive</strong> ("Şirket") tarafından aşağıda açıklanan kapsamda işlenebilecektir.</p>
          <p><strong className="text-zinc-300">Adres:</strong> Esentepe Mah. Talatpaşa Cad. No: 5/1, 34394 Şişli/İstanbul<br /><strong className="text-zinc-300">E-posta:</strong> info@medyatik.app<br /><strong className="text-zinc-300">Telefon:</strong> +90 532 168 62 82</p>
        </>
      ),
    },
    {
      title: 'İşlenen Kişisel Veriler',
      content: (
        <>
          <p>Web sitemizi ziyaret ettiğinizde ve iletişim formunu doldurduğunuzda aşağıdaki kişisel verileriniz işlenmektedir:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Kimlik bilgileri (ad, soyad)</li>
            <li>İletişim bilgileri (e-posta adresi, telefon numarası)</li>
            <li>Şirket bilgileri (çalıştığınız şirket adı)</li>
            <li>İletişim içeriği (mesaj metni)</li>
            <li>Çerez verileri (IP adresi, tarayıcı bilgileri, ziyaret edilen sayfalar)</li>
          </ul>
        </>
      ),
    },
    {
      title: 'Kişisel Verilerin İşlenme Amaçları',
      content: (
        <ul className="list-disc pl-5 space-y-1">
          <li>İletişim taleplerinizin yanıtlanması</li>
          <li>Hizmetlerimiz hakkında bilgi verilmesi</li>
          <li>Teklif ve proje süreçlerinin yürütülmesi</li>
          <li>Müşteri ilişkileri yönetimi</li>
          <li>Web sitesi performansının analizi ve iyileştirilmesi</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        </ul>
      ),
    },
    {
      title: 'Kişisel Verilerin Aktarılması',
      content: <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda; iş ortaklarımıza, hizmet aldığımız üçüncü taraf firmalara ve yasal zorunluluk halinde yetkili kamu kurum ve kuruluşlarına aktarılabilecektir.</p>,
    },
    {
      title: 'Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi',
      content: <p>Kişisel verileriniz, web sitemiz üzerinden elektronik ortamda, iletişim formları aracılığıyla ve çerezler vasıtasıyla toplanmaktadır. Kişisel verileriniz; açık rızanıza dayanarak, bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması kaydıyla ve veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması hukuki sebeplerine dayanılarak işlenmektedir.</p>,
    },
    {
      title: 'Kişisel Veri Sahibinin Hakları',
      content: (
        <>
          <p>KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
            <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
            <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
            <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
            <li>Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
            <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
            <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
            <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
          </ul>
        </>
      ),
    },
    {
      title: 'Başvuru Yöntemi',
      content: <p>Yukarıda belirtilen haklarınızı kullanmak için <strong className="text-zinc-300">info@medyatik.app</strong> adresine e-posta göndererek veya <strong className="text-zinc-300">Esentepe Mah. Talatpaşa Cad. No: 5/1, 34394 Şişli/İstanbul</strong> adresine yazılı olarak başvurabilirsiniz.</p>,
    },
    {
      title: 'Veri Saklama Süresi',
      content: <p>Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca ve yasal saklama süreleri dahilinde muhafaza edilecektir. Bu sürelerin sona ermesinin ardından kişisel verileriniz silinecek, yok edilecek veya anonim hale getirilecektir.</p>,
    },
  ];

  return <LegalPageLayout title="KVKK Aydınlatma Metni" date="Son Güncelleme: Aralık 2024" sections={sections} testId="kvkk-page" />;
}
